import React from 'react';
import styled from 'styled-components';

import { FONT } from '../../styles/color';


const Container = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: 20px;
	padding: 25px 0;
	border-bottom: ${ props => props.border === 'none' ? 'none' : `2px solid ${ FONT.mid }` };
	align-items: ${ props => props.align === 'center' ? 'center' : 'flex-start' };
`;

export default function FormContainer(props) {
  return (
	<Container style={ props.style } border={ props.border } align={ props.align }>
		{ props.children }
	</Container>
  )
}
